import { saveAs } from "file-saver";
import { useCallback, useState } from "react";

import { NotificationType } from "@transfr-inc/dashboard-components";
import { formatTimestap } from "@transfr-inc/dashboard-components/utils";

import container from "@src/container";

export function useDownloadPathwayPDF({ classroom, trainee, setNotification }) {
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const trekService = container?.trekService;

  const doDownloadPathwayPDF = useCallback(
    async (careerPlanId) => {
      if (!careerPlanId) {
        return;
      }

      setIsGeneratingPDF(true);
      try {
        const pdfBlob = await trekService.getPathwayPDF(careerPlanId);

        const filename = `${classroom.name} - Trek Pathway - ${
          trainee.firstName
        } ${trainee.lastName} - ${formatTimestap()}.pdf`;
        saveAs(pdfBlob, filename);

        setNotification({
          type: NotificationType.success,
          message: "Successfully generated PDF",
          icon: ["fa-solid", "circle-check"],
        });
      } catch {
        setNotification({
          type: NotificationType.error,
          message: "Something went wrong while generating the PDF",
          icon: ["fa-light", "fa-xmark"],
        });
      }
      setIsGeneratingPDF(false);
    },
    [classroom, trainee, setNotification]
  );

  return { isGeneratingPDF, doDownloadPathwayPDF };
}
